import { useCallback, useEffect, useState } from "react";

import type { EmblaCarouselType } from "../emblaCarouselTypes";

type UsePreviousNextButtonsType = {
  previousBtnDisabled: boolean;
  nextBtnDisabled: boolean;
  onPreviousBtnClick: () => void;
  onNextBtnClick: () => void;
};

export const usePreviousNextButtons = (emblaApi: EmblaCarouselType): UsePreviousNextButtonsType => {
  const [previousBtnDisabled, setPreviousBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPreviousBtnClick = useCallback(() => {
    if (!emblaApi) return;

    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextBtnClick = useCallback(() => {
    if (!emblaApi) return;

    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((api: NonNullable<EmblaCarouselType>) => {
    setPreviousBtnDisabled(!api.canScrollPrev());
    setNextBtnDisabled(!api.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect);
    emblaApi.on("select", onSelect);
  }, [emblaApi, onSelect]);

  return {
    previousBtnDisabled,
    nextBtnDisabled,
    onPreviousBtnClick,
    onNextBtnClick,
  };
};
